import styled, { css } from 'styled-components';

export const StyledImageContainer = styled.div`
  display: block;
  width: 100%;
  height: auto;
  padding-top: calc((${(props) => props.height} / ${(props) => props.width}) * 100%);
  overflow: hidden;
  position: relative;

  > span {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
  }

  img {
    object-position: center !important;
  }
`;

export const StyledImage = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  ${(props) => {
    const { displayImage } = props;

    if (displayImage === 'crop') {
      return css`
        display: none;
      `;
    }
    return null;
  }};
`;
